import { useGetConfigurationQuery } from '../services/configuration';
import { Weblab, WeblabTreatment } from './enum';

/**
 * Check if the weblab is launched T1
 */
export const isWeblabLaunched = (key: Weblab): boolean => {
  const { data: { weblabs } = {} } = useGetConfigurationQuery();
  if (weblabs && weblabs[key]) {
    const treatment = weblabs[key];
    return treatment === WeblabTreatment.T1;
  }
  return false;
};
